exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span.textSpan {\n  color: #495057;\n  font-size: 16px;\n  font-weight: 400; }\n\n.fa-facebook, .fa-facebook-f, .fa-facebook-square {\n  color: #3b5998; }\n\n.fa-twitter, .fa-twitter-square {\n  color: #00aced; }\n\n.fa-google-plus, .fa-google-plus-square {\n  color: #dd4b39; }\n\n.fa-youtube, .fa-youtube-play, .fa-youtube-square {\n  color: #bb0000; }\n\n.fa-tumblr, .fa-tumblr-square {\n  color: #32506d; }\n\n.fa-vine {\n  color: #00bf8f; }\n\n.fa-flickr {\n  color: #ff0084; }\n\n.fa-vimeo-square {\n  color: #aad450; }\n\n.fa-pinterest, .fa-pinterest-square {\n  color: #cb2027; }\n\n.fa-linkedin, .fa-linkedin-square {\n  color: #007bb6; }\n\n.fa-instagram {\n  color: #517fa4; }\n\n.fa-spotify {\n  color: #1ED760; }\n\na.likeLink i.fa-heart {\n  color: grey; }\n\na.likeLink:hover i.fa-heart {\n  color: red; }\n\n.rtlContent button.done-button {\n  font-size: 16px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/ProactiView/ProactiView-Client/src/app/shared/completeProcessModal/completeProcessModal.component.scss
// module id = ../../../../../src/app/shared/completeProcessModal/completeProcessModal.component.scss
// module chunks = main